import React from "react";
import { Check, Minus } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getTranslationsForLanguage } from "@/i18n";

export default function PricingComparisonTable({ plans, copy }) {
  const labels = copy || getTranslationsForLanguage("en", "billing").pricing;
  const allFeatures = Array.from(new Set(plans.flatMap((plan) => plan.features || []))).slice(0, 10);

  if (!allFeatures.length) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl font-black">{labels.compareTitle}</CardTitle>
        <p className="text-sm text-muted-foreground">{labels.compareDescription}</p>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto rounded-2xl border border-border">
          <table data-keep-table className="min-w-[720px] bg-card text-sm">
            <thead>
              <tr className="border-b border-border bg-muted/50">
                <th className="p-4 text-left font-black">{labels.feature}</th>
                {plans.map((plan) => (
                  <th key={plan.id || plan.tier} className="p-4 text-center font-black">{plan.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {allFeatures.map((feature) => (
                <tr key={feature} className="border-b border-border last:border-0">
                  <td className="p-4 font-semibold">{feature}</td>
                  {plans.map((plan) => {
                    const included = (plan.features || []).includes(feature);
                    return (
                      <td key={`${plan.id || plan.tier}-${feature}`} className="p-4 text-center">
                        {included ? (
                          <span className="mx-auto grid h-7 w-7 place-items-center rounded-full bg-success/10 text-success"><Check className="h-4 w-4" /></span>
                        ) : (
                          <span className="mx-auto grid h-7 w-7 place-items-center rounded-full bg-muted text-muted-foreground"><Minus className="h-4 w-4" /></span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}